import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from 'antd';
import './App.css';

// 导入公共组件
import AppHeader from './components/common/AppHeader';
import AppFooter from './components/common/AppFooter';

// 导入页面组件
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import IndicatorAnalysis from './pages/IndicatorAnalysis';
import WarningCenter from './pages/WarningCenter';
import BusinessServiceHall from './pages/BusinessServiceHall';
import DecisionLab from './pages/DecisionLab';
import Workbench from './pages/Workbench';

const { Content } = Layout;

function App() {
  return (
    <Router>
      <Layout className="app-layout">
        <AppHeader />
        <Content className="app-content">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/indicators" element={<IndicatorAnalysis />} />
            <Route path="/warnings" element={<WarningCenter />} />
            <Route path="/services" element={<BusinessServiceHall />} />
            <Route path="/decision-lab" element={<DecisionLab />} />
            <Route path="/workbench" element={<Workbench />} />
          </Routes>
        </Content>
        <AppFooter />
      </Layout>
    </Router>
  );
}

export default App; 